
import * as api_config from '../config/api_config'

export default {
  getFavorites(axios, type) {
    return axios.get(`${api_config.ADDRESS}/favorites?favorite[favorable_type]=${type}`, {headers: api_config.HEADERS});
  },
  addFavorite(axios, payload) {
    return axios.post(`${api_config.ADDRESS}/favorites`, {favorite: payload}, {headers: api_config.HEADERS});
  },
  removeFavorite(axios, id) {
    return axios.delete(`${api_config.ADDRESS}/favorites/${id}`, {headers: api_config.HEADERS});
  }
};
